import { render, staticRenderFns } from "./FabricWebhooks.vue?vue&type=template&id=be8617d0"
import script from "./FabricWebhooks.vue?vue&type=script&lang=js"
export * from "./FabricWebhooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports